import 'jqueryfileupload';
import AlerterView from 'chairisher/view/alerter';

import { getShouldAllowImages, getUploadUrl } from 'chairisher/context/file';
import { isPlainObject } from 'chairisher/util/type';

/**
 * View which handles uploading files.
 *
 * @param {Object} options Settings for the FileUploader
 * @param {jQuery} options.$el Field element containing the various upload components
 * @param {Array<Object>=} options.formData Optional initial data
 * @constructor
 */
export default class FileUploader {
    constructor({ $el, formData = [] }) {
        this.$el = $el;
        this.formData = formData;
    }

    /**
     * Bind the FileUploader for use.
     */
    bind() {
        const $uploader = this.$el.find('input[type=file]');
        const $uploadButton = this.$el.find('.js-btn-upload');
        const $filename = this.$el.find('.js-filename');
        const $uploadTriggers = this.$el.find('.js-btn-upload, .js-filename');

        let currentAlert;

        $uploader.fileupload({
            dataType: 'json',
            formData: this.formData,
            paramName: 'file',
            replaceFileInput: false,
            type: 'POST',
            url: getUploadUrl(),
            crossDomain: false,

            add: (event, data) => {
                if (currentAlert) {
                    currentAlert.remove();
                }

                $filename.hide();
                $uploadButton.hide();

                data.process().done(() => {
                    data.submit();
                });
            },

            done: (event, data) => {
                this.$el.find('.js-file-guid-input input').val(data.jqXHR.responseJSON.guid).trigger('change');
                this.$el.find('.js-file-name-input input').val(data.files[0].name);
                $filename.text(data.files[0].name).removeClass('placeholder');

                $filename.show();
                $uploadButton.show();
                this.$el.find('.progress').hide();
            },

            progressall: (event, data) => {
                this.updateProgressBar(Math.round((data.loaded / data.total) * 100));
            },

            fail: (event, data) => {
                let message;
                if (isPlainObject(data.jqXHR.responseJSON) && 'errors' in data.jqXHR.responseJSON) {
                    message = data.jqXHR.responseJSON.errors[0].message;
                } else if (getShouldAllowImages()) {
                    message = 'Please upload a valid .jpg, .gif, .png or .pdf file.';
                } else {
                    message = 'Please upload a valid .pdf file.';
                }

                currentAlert = AlerterView.error(message);
                $uploadButton.show();
                this.$el.find('.progress').hide();
            },
        });

        // bind AJAX image upload
        $uploadTriggers.on('click', (e) => {
            e.preventDefault();
            $uploader.trigger('click');
        });
    }

    /**
     * Updates the progress bar's width to match the percentage passed in.
     * If 0 is passed in, the progress bar is hidden.
     *
     * @param {number} percentComplete
     */
    updateProgressBar(percentComplete) {
        const $progressBar = this.$el.find('.progress-bar');
        const shouldSetActive = percentComplete >= 100;

        $progressBar.css('width', `${percentComplete}%`);
        $progressBar.toggleClass('active', shouldSetActive);
        $progressBar.closest('.progress').toggle(percentComplete > 0);
        $progressBar.toggle(percentComplete > 0);
    }
}
